import { getGridSpot, findPath, BLOCK_SIZE } from './utils'
import Enemy from './Enemy'
import Wall from './Wall'
import Tower from './Tower'
import Ground from './Ground'
import Start from './Start'
import Goal from './Goal'

const canvas = document.querySelector('canvas')
const c = canvas.getContext('2d')

canvas.width = BLOCK_SIZE * 15
canvas.height = BLOCK_SIZE * 15

const mouse = {
  x: 0,
  y: 0
}

let currentWave = 1
let waveActive = false

let lives = 10
let money = 12
let movePath = []
let mouseDownCell = null
let enemies = []

const initialGrid = [
  ['WALL','WALL','WALL','WALL','WALL','WALL','WALL','WALL','WALL','WALL','WALL','WALL','WALL','WALL','WALL'],
  ['WALL','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','WALL'],
  ['WALL','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','WALL'],
  ['WALL','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','WALL'],
  ['WALL','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','WALL'],
  ['WALL','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','WALL'],
  ['WALL','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','WALL'],
  ['GOAL','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','START'],
  ['WALL','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','WALL'],
  ['WALL','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','WALL'],
  ['WALL','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','WALL'],
  ['WALL','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','WALL'],
  ['WALL','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','WALL'],
  ['WALL','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','GROUND','WALL'],
  ['WALL','WALL','WALL','WALL','WALL','WALL','WALL','WALL','WALL','WALL','WALL','WALL','WALL','WALL','WALL'],
]

const MAX_WIDTH = BLOCK_SIZE * initialGrid[0].length
canvas.style.width = '100%'
canvas.style.maxWidth = `${MAX_WIDTH}px`

const isOutOfGrid = (gridSpot) => {
  if(!objects[gridSpot.y] || !objects[gridSpot.y][gridSpot.x]) {
    return true
  }

  return false
}

const mouseDown = () => {
  mouseDownCell = getGridSpot(mouse)
}

const mouseUp = () => {
  const mouseUpCell = getGridSpot(mouse)
  if(isOutOfGrid(mouseUpCell)) {
    return
  }

  const cellObject = objects[mouseUpCell.y][mouseUpCell.x]

  if(mouseDownCell.x === mouseUpCell.x &&
    mouseDownCell.y === mouseUpCell.y) {

    if(cellObject.type === 'GROUND') {
      addTower(mouseUpCell)
    } else if (cellObject.type === 'TOWER') {
      removeTower(mouseUpCell)
    }
  }
}

const setMouseSpot = (x,y) => {
  let percentage = window.innerWidth > MAX_WIDTH ? 1 : MAX_WIDTH/window.innerWidth
  mouse.x = (x + window.scrollX) * percentage
  mouse.y = (y + window.scrollY) * percentage
}



addEventListener('mousedown', mouseDown)
addEventListener('mouseup', mouseUp)
addEventListener('mousemove', (event) => {
  event.preventDefault()
  setMouseSpot(event.clientX, event.clientY)
})

addEventListener('touchstart', (event) => {
  event.preventDefault()
  const touches = event.changedTouches
  setMouseSpot(touches[0].pageX, touches[0].pageY)

  const mouseUpCell = getGridSpot(mouse)
  if(isOutOfGrid(mouseUpCell)) {
    return
  }

  const cellObject = objects[mouseUpCell.y][mouseUpCell.x]

  if(cellObject.type === 'GROUND') {
    addTower(mouseUpCell)
  } else if (cellObject.type === 'TOWER') {
    removeTower(mouseUpCell)
  }
})
/* addEventListener('touchend', (event) => {
  event.preventDefault()
  const touches = event.changedTouches
  setMouseSpot(touches[0].pageX, touches[0].pageY)
  mouseUp()
}) */
/* addEventListener('touchmove', (event) => {

}) */

const successEnemy = (toKill) => {
  lives--

  killEnemy(toKill)
  updateStats()

  if (lives <= 0) {
    enemies = []
    alert('Game Over')
    init()
  }
}

const killEnemy = (toKill) => {
  money += 5
  enemies = enemies.filter(i => i !== toKill)
  toKill = null
  updateStats()
}

document.getElementById('NEXT_WAVE').addEventListener('click', startNextWave)

function startNextWave() {
  const waveSpeed = 2000
  for (var i = 0; i < currentWave; i++) {
    setTimeout(() => {
      const enemy = new Enemy('WALKER', movePath, successEnemy, killEnemy)
      enemies.push(enemy)
    }, waveSpeed/currentWave*i)
  }

  currentWave++
  money += currentWave
  updateStats()
}


let objects
const addTower = (gridSpot) => {
  if(isOutOfGrid(gridSpot)) {
    return
  }

  if(money < 1) {
    alert('Not enough money')
    return
  }

  if(waveActive) {
    alert('Can\'t build while wave is active')
    return
  }

  objects[gridSpot.y][gridSpot.x] = new Tower('BASIC', gridSpot)

  updateObjects()
  const pathForCloned = findPath(objects)

  if (!pathForCloned[0]) {
    objects[gridSpot.y][gridSpot.x] = new Ground(gridSpot)
    updateObjects()
  } else {
    money -= 1
  }

  drawMap()
  updateStats()
}

const removeTower = (gridSpot) => {
  objects[gridSpot.y][gridSpot.x] = new Ground(gridSpot)
  money += 0.5
  drawMap()
  updateStats()
}

const updateObjects = () => {
  objects.forEach((row, rowIndex) => {
    row.forEach((object, cellIndex) => {
      object.reset()
      object.addNeighbors(
        objects[rowIndex-1] ? objects[rowIndex-1][cellIndex] : undefined,
        objects[rowIndex] ? objects[rowIndex][cellIndex+1] : undefined,
        objects[rowIndex+1]? objects[rowIndex+1][cellIndex] : undefined,
        objects[rowIndex] ? objects[rowIndex][cellIndex-1] : undefined)

      object.addDiagonalNeighbors(
        objects[rowIndex-1] ? objects[rowIndex-1][cellIndex-1] : undefined,
        objects[rowIndex-1] ? objects[rowIndex-1][cellIndex+1] : undefined,
        objects[rowIndex+1] ? objects[rowIndex+1][cellIndex+1] : undefined,
        objects[rowIndex+1] ? objects[rowIndex+1][cellIndex+1] : undefined)

      object.isPartOfPath = false
    })
  })
}

const drawMap = () => {
  updateObjects()
  movePath = findPath(objects)
  movePath.forEach((item) => {
    item.isPartOfPath = true
  })
}

const updateStats = () => {
  document.getElementById('life').innerHTML = lives
  document.getElementById('money').innerHTML = money
  document.getElementById('wave').innerHTML = currentWave
}

function init() {
  currentWave = 1
  waveActive = false

  lives = 10
  money = 12
  movePath = []
  mouseDownCell = null

  objects = []
  updateStats()

  initialGrid.forEach((row, rowIndex) => {
    row.forEach((cell, cellIndex) => {
      let tile = null
      switch(cell) {
      case 'WALL':
        tile = new Wall({
          x: cellIndex,
          y: rowIndex
        })
        break
      case 'START':
        tile = new Start({
          x: cellIndex,
          y: rowIndex
        })
        break
      case 'GOAL':
        tile = new Goal({
          x: cellIndex,
          y: rowIndex
        })
        break
      default :
        tile = new Ground({
          x: cellIndex,
          y: rowIndex
        })
        break
      }

      if(!objects[rowIndex]) {
        objects[rowIndex] = []
      }

      objects[rowIndex][cellIndex] = tile
    })
  })

  drawMap()
}

function draw() {
  c.clearRect(0, 0, canvas.width, canvas.height)

  const mousegridSpot = getGridSpot({
    x: mouse.x,
    y: mouse.y
  })

  objects.forEach(row => {
    row.forEach(object => {
      if (object.gridSpot.x === mousegridSpot.x && object.gridSpot.y === mousegridSpot.y) {
        object.update(c, true)
      } else {
        object.update(c, false)
      }

      if (object.type === 'TOWER') {
        object.shoot(enemies)
      }
    })
  })

  enemies.forEach(enemy => {
    enemy.update(c)
  })
}

function animate() {
  requestAnimationFrame(animate)
  waveActive = enemies[0] ? true : false
  draw()
}

init()
animate()
